import throttle from 'lodash/throttle';
import {useCallback, useContext, useRef} from 'react';
import {useSelector} from 'react-redux';
import {useBackground} from '~/common/FabricInvitation/EventCreateDesign/components/Background/actions/useBackground';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {
  selectBackgroundColor,
  selectRecentBackgroundColors,
} from '~/common/fabric/reducers/fabricDesign/selectors';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {ColorPicker} from './ColorPicker';

// biome-ignore lint/suspicious/noEmptyBlockStatements: empty block
export const BackgroundColorPicker = ({onColorChange = () => {}}) => {
  const {bkgColor, setBkgColor} = useContext(EventCreateContext);
  const throttledColorChange = useRef(throttle(onColorChange, 500)).current;
  const isLargishAndUp = useIsLargishAndUp();
  const recentBackgroundColors = useSelector(selectRecentBackgroundColors);
  const backgroundColor = useSelector(selectBackgroundColor);
  const {selectedBackground} = useBackground();
  const selectedColor = (!selectedBackground?.src && backgroundColor) || '';

  const onChangeHandler = useCallback(
    (color) => {
      setBkgColor(color);
      throttledColorChange(color);
    },
    [setBkgColor, throttledColorChange]
  );

  return (
    <ColorPicker
      recentColors={recentBackgroundColors}
      reduxKey="recentBackgroundColors"
      color={bkgColor}
      isActive={!!backgroundColor}
      className="create-flow-color-picker"
      onChangeHandler={onChangeHandler}
      isolateDropper={!isLargishAndUp}
      highlight={!isLargishAndUp}
      selectedColor={selectedColor}
      recentColorLimit={isLargishAndUp ? 6 : 3}
    />
  );
};
